module.exports = __webpack_public_path__ + "static/media/45.77f24c38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/45.jpg
// module id = 606
// module chunks = 0